import { IconButton, Tooltip } from '@chakra-ui/react';
import { faRulerHorizontal } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';
import SparkelIcon from '../icon/SparkelIcon';

interface MeasureToolButtonProps {
  isMeasureActive: boolean;
  onToggleMeasure: () => void;
}

export default function MeasureToolButton({
  isMeasureActive,
  onToggleMeasure,
}: MeasureToolButtonProps) {
  const { t } = useTranslation('project');

  return (
    <Tooltip label={t('viewer-interactions.measure-toggle')}>
      <IconButton
        aria-label="Measure tool"
        icon={<SparkelIcon icon={faRulerHorizontal} />}
        isRound
        isActive={isMeasureActive}
        variant="solid-no-transparent"
        colorScheme="gray"
        size="xs"
        onClick={onToggleMeasure}
      />
    </Tooltip>
  );
}
